/**
 * Moves the discount tiers mixin properties up and down.
 */
var discountTiersMixin = {
	data: function () {
		return {
			discountTiers: vueProduct_DATA.discountTiers,
			discountBarStyle: {
				width: '0%',
				left: '0%'
			},
		}
	},
	methods: {
		/**
		* Calculates the style of the discount bar based on the product quantity and discount tiers.
		*/
		calculateDiscountBarStyle() {
			const quantity = this.product.quantity;
			const discountTiers = this.discountTiers;

			let currentTier;
			let tierQuantity;
			let nextTier;

			discountTiers.forEach((element, index) => {
				if (element.key <= quantity) {
					currentTier = index;
					tierQuantity = parseInt(element.key);
				}
			});

			if (discountTiers[currentTier + 1] !== undefined) {
				let nextTierTemp = discountTiers[currentTier + 1];
				nextTier = nextTierTemp ? parseInt(nextTierTemp.key) : NaN;
			} else {
				nextTier = 99999999;
			}

			const addOn = (100 * 1) / discountTiers.length;
			let widthPercentage = 0;

			if ((100 * currentTier) / discountTiers.length + addOn !== addOn) {
				if (quantity < nextTier && quantity >= tierQuantity) {
					widthPercentage = (100 * currentTier) / discountTiers.length;
				}
			}

			const leftPercentage = (100 * 1) / discountTiers.length;

			// Update the reactive `discountBarStyle` property
			this.discountBarStyle = {
				width: `calc(${widthPercentage}% + 10px)`,
				left: `${leftPercentage}%`
			};
		}
	},
};
